import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';
import { FormSearch } from 'app/models/dashboard/FormStatus';
import { ReceivingFormView } from 'app/models/inventory/receivingFormView';
import { ReceivingMatchLine } from 'app/models/inventory/receivingMatch';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';

@Injectable({
	providedIn: 'root',
})
export class ReceivingFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}inventory/clients/$$clientId$$/receiving-form`, httpClient, utilityService);
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	/** EN-5074: the PO's completed receiving lines, with what is matched to this invoice and to others. */
	getInvoiceMatchLines(clientId: string, poNumber: string | number, apInvoiceId?: string | null): Observable<ReceivingMatchLine[]> {
		let params = new HttpParams();
		if (apInvoiceId) {
			params = params.set('apInvoiceId', apInvoiceId);
		}
		return this.httpClient.get<ReceivingMatchLine[]>(
			`${this.getUrl(clientId)}/${encodeURIComponent(String(poNumber))}/invoice-match-lines`,
			{ params }
		);
	}
	getAllCompletedReceivingFormsWithItems(clientId: string) {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/completed-receiving-form-with-items`);
	}
}
